/**
 * Resizes an image based on specified requirements
 * @param imageData - The source image data URL
 * @param options - The resize options (maxWidth, maxHeight, maxSizeInBytes)
 * @returns A promise that resolves to the resized image data URL
 */
const resizeImage = async (
    imageData: string,
    options: {maxWidth?: number; maxHeight?: number; maxSizeInBytes?: number},
): Promise<string> => new Promise(resolve => {
    const img = new Image();

    img.onload = async () => {
        const {maxWidth, maxHeight, maxSizeInBytes} = options;

        const canvas = document.createElement('canvas');
        let {width} = img;
        let {height} = img;

        if (maxWidth && width > maxWidth) {
            const ratio = maxWidth / width;

            width = maxWidth;
            height *= ratio;
        }

        if (maxHeight && height > maxHeight) {
            const ratio = maxHeight / height;

            height = maxHeight;
            width *= ratio;
        }

        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext('2d');

        if (ctx) {
            ctx.drawImage(img, 0, 0, width, height);

            let resizedData = canvas.toDataURL('image/png');

            if (maxSizeInBytes) {
                let quality = 0.9;

                while (resizedData.length > maxSizeInBytes && quality > 0.1) {
                    resizedData = canvas.toDataURL('image/jpeg', quality);
                    quality -= 0.1;
                }
            }

            resolve(resizedData);
        } else {
            resolve(imageData);
        }
    };
    img.src = imageData;
});

export default resizeImage;
